import React from 'react';

const PlusBoxIcon = ({ fill = 'currentColor', width = '24', height = '24' }) => (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
        <path d="M19.0002 11H13.0002V5H11.0002V11H5.00024V13H11.0002V19H13.0002V13H19.0002V11Z" fill={fill} />
    </svg>
);

export default PlusBoxIcon;
